import React from "react";
import Inbox from "@/components/messages/Inbox";
export default function DoctorMessages() { return <Inbox role="doctor"/>; }
